// @ts-nocheck
import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { withRouter } from './router-compat';
import { observer, inject } from "./stores/mobx-compat";
import Responsive from './components/shared/Responsive';
import { ToastContainer } from 'react-toastify';
import _ from 'lodash';

import { userRoleType, planNames } from './enums';
import './App.css';

import DashboardLayout from './components/DashboardLayout';
import Dashboard from './components/DashboardTabs/Dashboard';
import Reporting from './components/DashboardTabs/Reporting';
import Forms from './components/DashboardTabs/Forms';
import FAQ from './components/DashboardTabs/FAQ';
import Admin from './components/DashboardTabs/Admin';
import Integrations from './components/DashboardTabs/Integrations';
import EditForms from './components/DashboardTabs/Forms/EditForms/index';

import Payments from './components/Payments';
import Setup from './components/Setup';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import TwoFAPage from './components/TwoFAPage';
import EmailVerificationPage from './components/EmailVerificationPage';
import Settings from './components/Settings';
import Tour from './components/Tour';
import Recover from './components/DashboardTabs/Recover';
import AMP from './components/DashboardTabs/AMP';

class App extends Component {
  /** components without icon property will not appear on side nav */
  publicRouteConfigs = [
    {
      name: 'Login',
      path: '/',
      exact: true,
      component: LoginPage,
    },
    {
      name: 'LoginAlias',
      path: '/login',
      component: LoginPage,
    },
    {
      name: 'Register',
      path: '/register',
      component: RegisterPage,
    },
    {
      name: 'ForgotPassword',
      path: '/forgot-password',
      component: ForgotPasswordPage,
    },
  ]

  adminRouteConfigs = [
    {
      name: 'Admin',
      label: 'Admin',
      path: '/admin',
      icon: 'shield',
      group: 'admin',
      component: Admin,
    },
  ]

  userRouteConfigs = [
    {
      name: 'Dashboard',
      label: 'Dashboard',
      path: '/dashboard',
      icon: 'chart line',
      group: 'main',
      component: Dashboard,
    },
    {
      name: 'Reporting',
      label: 'Reporting',
      path: '/reporting',
      icon: 'thumbtack',
      group: 'insights',
      component: Reporting,
    },
    {
      name: 'Forms',
      label: 'Forms',
      path: '/forms',
      icon: 'clipboard outline',
      group: 'main',
      component: Forms,
      exact: true,
    },
    {
      name: 'EditForms',
      path: '/forms/:safePath',
      component: EditForms,
      exact: true,
    },
    {
      name: 'Integrations',
      path: '/integrations/*',
      component: Integrations,
    },
    {
      name: 'Setup',
      label: 'Setup',
      path: '/setup',
      icon: 'sliders horizontal',
      group: 'setup',
      component: Setup,
    },
    {
      name: 'FAQ',
      label: 'FAQ',
      path: '/faq',
      icon: 'info',
      group: 'account',
      component: FAQ,
    },
    {
      name: 'Payments',
      label: 'Payments',
      path: '/payments',
      icon: 'credit card outline',
      group: 'account',
      component: Payments,
    },
    {
      name: 'Settings',
      path: '/settings',
      component: Settings,
    },
  ]

  paidRouteConfigs = [
    {
      name: 'Recover',
      label: 'Recover',
      path: '/recover',
      icon: 'mail outline',
      group: 'main',
      component: Recover,
    },
    {
      name: 'AMP',
      label: 'AMP',
      path: '/amp',
      icon: 'paper plane outline',
      group: 'main',
      component: AMP,
    },
  ]

  componentDidUpdate = () => {
    this.reroute();
  }
  componentDidMount() {
    this.props.history.listen(() => {
      this.props.store.clearAllToasts();
    });
  }

  reroute = () => {
    const { history, history: { location: { pathname } } } = this.props;
    const { user } = this.props.store.auth;

    const publicPaths = ['/', '/login', '/register', '/forgot-password'];
    if (user.user_id === null) {
      return;
    }

    if (_.isEmpty(user)) {
      if (!publicPaths.includes(pathname)) {
        history.push('/');
      }
    } else if (!user.email_verified) {
      if (pathname !== '/unverifiedEmail') {
        history.push('/unverifiedEmail');
      }
    } else if (user.twoFaType && !user.verified) {
      if (pathname !== '/authenticate') {
        history.push('/authenticate');
      }
    } else if (pathname === '/'
      || pathname === '/login'
      || pathname === '/register'
      || pathname === '/forgot-password'
      || pathname === '/unverifiedEmail'
      || pathname === '/authenticate') {
      if (user.role === userRoleType.superadmin) {
        history.push('/admin');
      } else {
        history.push('/dashboard');
      }
    }
  }

  renderConfigRoutes = (configs) => (
    <Routes>
      {configs.map((c) => {
        const C = c.component;
        return <Route key={c.name} path={c.path} element={C ? <C /> : null} />;
      })}
    </Routes>
  );

  get publicRoutes() {
    return this.renderConfigRoutes(this.publicRouteConfigs);
  }

  unverifiedEmailRoutes = () => (
    <Routes>
      <Route path="/unverifiedEmail" element={<EmailVerificationPage />} />
    </Routes>
  )

  unverified2FARoutes = () => (
    <Routes>
      <Route path="/authenticate" element={<TwoFAPage />} />
    </Routes>
  )

  get privateRoutes() {
    const routeConfigs = [
      {
        name: 'Home',
        path: '/',
      },
      ...this.userRouteConfigs,
    ];

    const isSpoofed = localStorage.getItem('spoofed') === '1';
    if (this.props.store.auth.user.role === userRoleType.superadmin || isSpoofed) {
      routeConfigs.unshift(...this.adminRouteConfigs);
    }

    // Premium feature gate disabled — paid-only routes are always available.
    routeConfigs.push(...this.paidRouteConfigs);

    if (['wix', 'shopify'].includes(this.props.store.initQueryParams.partner)) {
      _.remove(routeConfigs, config => config.name === 'Payments');
    }

    return (
      <DashboardLayout routeConfigs={routeConfigs}>
        {this.renderConfigRoutes(routeConfigs)}
        <Tour />
      </DashboardLayout>
    );
  }

  get availableRoutes() {
    const { user } = this.props.store.auth;

    if (user.user_id === null) {
      return this.publicRoutes;
    } else if (!user.email_verified) {
      return this.unverifiedEmailRoutes();
    } else if (user.twoFaType && !user.verified) {
      return this.unverified2FARoutes();
    } else {
      return this.privateRoutes;
    }
  }

  render() {
    return (
      <Responsive
        className="App"
        fireOnMount
        onUpdate={this.props.store.ui.onWindowResize}
      >
        {this.availableRoutes}
        <ToastContainer className="mov-toasts" position="top-right" hideProgressBar />
      </Responsive>
    );
  }
}

export default withRouter(inject('store')(observer(App)));
